import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f595a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Rewards", -1))
const _hoisted_4 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RewardOverviewSingle = _resolveComponent("RewardOverviewSingle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: {
          name: 'List',
          params: {
            category: 'reward',
            lang: _ctx.$i18n.locale
          }
        },
        class: "btn btn-sm",
        textContent: _toDisplayString(_ctx.$t('view-all'))
      }, null, 8, ["to", "textContent"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (reward, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: i
        }, [
          _createVNode(_component_RewardOverviewSingle, { item: reward }, null, 8, ["item"])
        ]))
      }), 128))
    ])
  ]))
}